import React, { useEffect, useState, useContext, useCallback  } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS, API_BASE_DOCS } from "../../../config/api";
import Pagination from "../../../components/private/pagination";
import SearchSelect from "../../../components/private/searchselect";


const OccupationalExams = () => {
  const { token, authFetch } = useContext(AuthContext);

  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  const [curriculums, setCurriculums] = useState([]);

  const [filter, setFilter] = useState({ searchQuery: "" });
  const [stateFilter, setStateFilter] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  const [showModal, setShowModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const [selectedExam, setSelectedExam] = useState(null);
  // ESTADOS PARA EL MODAL DE DOCUMENTOS
  const [showUserExamsModal, setShowUserExamsModal] = useState(false);
  const [userExams, setUserExams] = useState([]);


  const [editData, setEditData] = useState({
    observation_exam: "",
    state_exam: "",
    document_exam_file: null,
  });

  const [createData, setCreateData] = useState({
    id_curriculum: "",
    observation_exam: "",
    document_exam: null,
    state_exam:"Sin revisar",
  });

  // -------------------------------
  // MODAL DOCUMENTOS DE UN USUARIO
  // -------------------------------
  const openUserExamsModal = async (id_curriculum) => {
    try {
      const data = await authFetch(
        ENDPOINTS.getExamsByUser + "?id_curriculum=" + id_curriculum,
        { method: "GET" }
      );

      if (data.success) setUserExams(data.documents);
    } catch (error) {
      console.error("Error cargando exámenes:", error);
    }

    setShowUserExamsModal(true);
  };

  // -------------------------------
  //   CARGAR CURRICULUMS
  // -------------------------------
const loadCurriculums = useCallback(async () => {
  try {
    const data = await authFetch(ENDPOINTS.getCurriculum, {
      method: "GET",
    });
    if (data.success) setCurriculums(data.data);
  } catch (error) {
    console.error("Error cargando curriculums:", error);
  }
}, [authFetch]);

  const curriculumOptions = curriculums.map((c) => ({
  value: c.Id, // 👈 lo que se envía al backend
  label: `${c.first_name} ${c.last_name} — ${c.document}`, // 👈 lo visible
}));


  // -------------------------------
  //          PAGINACIÓN
  // -------------------------------
  const filteredExams = exams.filter((exam) => {
    const query = filter.searchQuery.toLowerCase().trim();

    const matchId = exam.Id_curriculum?.toString().includes(query);

    const fullName = `${exam.user_first_name} ${exam.user_last_name}`.toLowerCase();
    const matchName = fullName.includes(query);

    const matchState =
      stateFilter === "" ||
      exam.state_exam?.toLowerCase() === stateFilter.toLowerCase();

    return (matchId || matchName) && matchState;
  });

  const totalPages = Math.max(
    1,
    Math.ceil(filteredExams.length / recordsPerPage)
  );

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const currentExams = filteredExams.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  // -------------------------------
  //       MODAL EDITAR
  // -------------------------------
  const openModal = (exam) => {
    setSelectedExam(exam);
    setEditData({
      observation_exam: exam.observation_exam || "",
      state_exam: exam.state_exam || "Sin revisar",
      document_exam_file: null,
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedExam(null);
    setShowModal(false);
  };

  const handleEditChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setEditData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setEditData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleUpdateExam = async () => {
    if (!selectedExam) return;

    const formData = new FormData();
    formData.append("id_examen", selectedExam.id);
    formData.append("state_exam", editData.state_exam);
    formData.append("observation_exam", editData.observation_exam);

    try {
      const res = await fetch(ENDPOINTS.updateOccupationalExamById, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const data = await res.json();

      if (data.success) {
        alert("Examen actualizado correctamente");
        loadExams();
        closeModal();
      } else alert(data.message);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // -------------------------------
  //        CARGAR EXÁMENES
  // -------------------------------
  const loadExams = useCallback(async () => {
    setLoading(true);
    try {
      const data = await authFetch(ENDPOINTS.getOccupationalExam, {
        method: "GET",
      });

      if (data.success) setExams(data.data);
    } catch (error) {
      console.error("Error al cargar exámenes:", error);
    } finally {
      setLoading(false);
    }
  }, [authFetch]);
  // -------------------------------
  //        CREAR EXAMEN
  // -------------------------------
  const openCreateModal = () => {
    setCreateData({
      id_curriculum: "",
      observation_exam: "",
      document_exam: null,
      state_exam: "Sin revisar",
    });
    setShowCreateModal(true);
  };

  const closeCreateModal = () => setShowCreateModal(false);

  const handleCreateChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setCreateData((prev) => ({ ...prev, document_exam: files[0] }));
    } else {
      setCreateData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleCreateExam = async () => {
    if (!createData.id_curriculum) return alert("Seleccione un curriculum");
    if (!createData.document_exam) return alert("Debe adjuntar un documento");

    const formData = new FormData();
    formData.append("id_curriculum", createData.id_curriculum);
    formData.append("observation_exam", createData.observation_exam);
    formData.append("document_exam", createData.document_exam);
    formData.append("state_exam", createData.state_exam);

    try {
      const res = await fetch(ENDPOINTS.createExamOccupational, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const data = await res.json();

      if (data.success) {
        alert("Examen creado correctamente");
        closeCreateModal();
        loadExams();
      } else {
        alert(data.message || "Error al crear el examen");
      }
    } catch (error) {
      console.error("Error creando examen:", error);
    }
  };

  // -------------------------------
  //       EFECTO INICIAL
  // -------------------------------
  useEffect(() => {
    if (!token) return;

    loadExams();
    loadCurriculums();
  }, [token, loadExams, loadCurriculums]);

  // -------------------------------
  //             RENDER
  // -------------------------------
  if (loading) return <p>Cargando exámenes ocupacionales...</p>;

  return (
    <div className="container mt-4 p-4">
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Exámenes ocupacionales</h2>

        <button className="btn btn-outline-pink" onClick={openCreateModal}>
          <i className="bi bi-plus-lg me-1"></i> Nuevo examen
        </button>
      </div>

      {/* FILTROS */}
      <div className="row mb-3">
        <div className="col-md-8">
          <label className="m-1">Buscar por colaborador o por COD</label>
          <input
            type="text"
            className="form-control"
            value={filter.searchQuery}
            onChange={(e) => {
              setFilter({ ...filter, searchQuery: e.target.value });
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="col-md-4">
          <label className="m-1">Filtrar por estado:</label>
          <select
            className="form-select"
            value={stateFilter}
            onChange={(e) => {
              setStateFilter(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">Todos</option>
            <option value="Sin revisar">Sin revisar</option>
            <option value="Aprobado">Aprobado</option>
            <option value="Rechazado">Rechazado</option>
          </select>
        </div>
      </div>

      {/* TABLA */}
      {currentExams.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th>COD</th>
                <th>Colaborador</th>
                <th>Documento</th>
                <th>Observación</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {currentExams.map((exam) => (
                <tr key={exam.Id}>
                  <td>COD{exam.Id_curriculum}</td>
                  <td>
                    {exam.user_first_name} {exam.user_last_name}
                  </td>
                  <td>
                    <button
                      className="btn btn-outline-purple btn-sm"
                      onClick={() => openUserExamsModal(exam.Id_curriculum)}
                    >
                      Ver exámenes
                    </button>
                  </td>
                  <td>{exam.observation_exam}</td>
                  <td>{exam.state_exam}</td>
                  <td>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => openModal(exam)}
                    >
                      Modificar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* NUEVA PAGINACIÓN */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />
        </>
      ) : (
        <p>No hay exámenes ocupacionales registrados.</p>
      )}

      {/* MODALES → Mantengo tus modales exactos, sin cambios */}
      {/* MODAL EDITAR */}
      {showModal && selectedExam && (
        <div className="modal fade show d-block" style={{ background: "#00000090" }}>
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Modificar Examen</h5>
                <button className="btn-close" onClick={closeModal}></button>
              </div>

              <div className="modal-body">

                {/* OBSERVACIÓN */}
                <label className="form-label mt-3">Observación</label>
                <textarea
                  name="observation_exam"
                  className="form-control"
                  value={editData.observation_exam}
                  onChange={handleEditChange}
                ></textarea>

                {/* ESTADO */}
                <label className="form-label mt-3">Estado</label>
                <select
                  name="state_exam"
                  className="form-select"
                  value={editData.state_exam}
                  onChange={handleEditChange}
                >
                  <option value="Sin revisar">Sin revisar</option>
                  <option value="Aprobado">Aprobado</option>
                  <option value="Rechazado">Rechazado</option>
                </select>

              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>
                  Cancelar
                </button>
                <button className="btn btn-outline-pink" onClick={handleUpdateExam}>
                  Guardar cambios
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* MODAL CREAR */}
      {showCreateModal && (
        <div className="modal fade show d-block" style={{ background: "#00000090" }}>
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Nuevo Examen Ocupacional</h5>
                <button className="btn-close" onClick={closeCreateModal}></button>
              </div>

              <div className="modal-body">
                {/* SELECT CURRICULUM */}
                <label className="form-label">Seleccione colaborador</label>
                <SearchSelect
                    options={curriculumOptions}
                    placeholder="Buscar colaborador..."
                    value={createData.id_curriculum}
                    onChange={(value) =>
                      setCreateData((prev) => ({
                        ...prev,
                        id_curriculum: value, // 👈 ya es el ID
                      }))
                    }
                  />



                {/* DOCUMENTO */}
                <label className="form-label">Documento PDF</label>
                <input
                  type="file"
                  className="form-control mb-3"
                  name="document_exam"
                  accept="application/pdf"
                  onChange={handleCreateChange}
                />

                {/* OBSERVACIÓN */}
                <label className="form-label">Observación</label>
                <textarea
                  className="form-control"
                  name="observation_exam"
                  value={createData.observation_exam}
                  onChange={handleCreateChange}
                ></textarea>

                {/* ESTADO */}
                <label className="form-label mt-3">Estado del examen</label>
                <select
                  className="form-select"
                  name="state_exam"
                  value={createData.state_exam}
                  onChange={handleCreateChange}
                >
                  <option value="Sin revisar">Sin revisar</option>
                  <option value="Aprobado">Aprobado</option>
                  <option value="Rechazado">Rechazado</option>
                </select>

              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeCreateModal}>
                  Cancelar
                </button>
                <button className="btn btn-outline-pink" onClick={handleCreateExam}>
                  Crear Examen
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* MODAL DOCUMENTOS */}
      {showUserExamsModal && (
        <div className="modal fade show d-block" style={{ background: "#00000090" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Documentos del examen ocupacional</h5>
                <button className="btn-close" onClick={() => setShowUserExamsModal(false)}></button>
              </div>

              <div className="modal-body">
                {userExams.length > 0 ? (
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Nombre del archivo</th>
                        <th>Ver PDF</th>
                      </tr>
                    </thead>

                    <tbody>
                      {userExams.map((doc) => (
                        <tr key={doc.url}>
                          <td>{doc.name}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-pink"
                              onClick={() =>
                                window.open(API_BASE_DOCS + doc.url, "_blank")
                              }
                            >
                              Ver
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No hay documentos para este colaborador.</p>
                )}
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowUserExamsModal(false)}>
                  Cerrar
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default OccupationalExams;
